import React from 'react';
import cn from 'classnames';

import {IIFrameProps} from './IIFrame';

const IFrame = (props: IIFrameProps) => {
	let classes = 'responsive-iframe responsive-iframe--full-width';
	const isFixedDimensionSet = !!props.width;

	return (
		<div className={cn({
			[classes]: !isFixedDimensionSet,
		})}>
			<iframe
				allow={props.allow}
				height={props.height}
				loading={props.loading}
				name={props.name}
				referrerPolicy={props.referrerPolicy}
				sandbox={props.sandbox}
				seamless={props.seamless}
				src={props.src}
				srcDoc={props.srcDoc}
				width={props.width}
				{...props.customAttributes}
			/>
		</div>
	);
};

export default IFrame;
